import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

const url = process.env.VUE_APP_BILL_URL
const instance = axios.create({
  baseURL: url
})
instance.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
let logoutPage = ''
instance.interceptors.request.use(reqConfig => {
  if (Vue.prototype.$getCookie('comLoginToken')) {
    const token = Vue.prototype.$getCookie('comLoginToken').split('token=').pop()
    const xCorrelationId = Vue.prototype.$getGuid()
    reqConfig.headers = {
      kingnetauth: `Community ${token}`,
      'X-Correlation-Id': xCorrelationId
    }
    Sentry.setTag('X-Correlation-Id', xCorrelationId)
  }
  return reqConfig
}, err => {
  return Promise.reject(err)
})
instance.interceptors.response.use(
  res => res,
  err => {
    // eslint-disable-next-line eqeqeq
    if (err && err.response && (err.response.status == 401 || err.response.status == 403)) {
      // eslint-disable-next-line eqeqeq
      if (logoutPage != router.history.current.name) {
        logoutPage = router.history.current.name
        Vue.prototype.$alert(`${err.response.data.ErrorMessage.Description}`, '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          // eslint-disable-next-line eqeqeq
          if (err.response.status == 401) {
            router.push({ name: 'LoginMain' })
          // eslint-disable-next-line eqeqeq
          } else if (err.response.status == 403) {
            Vue.prototype.$toMainPage()
          }
        })
      } else {
        logoutPage = ''
      }
    }
    return Promise.reject(err)
  }
)

// Swagger: https://bs-dev.kingnetsmart.com.tw/swagger/index.html#/
export const apiBillservice = {
  BillBulk: {
    GetBillBulkList: (requestData, config) => instance.get('/BillBulk', Object.assign({}, { params: requestData }, config)), // 取得期別列表
    GetBillBulkBasicList: (config) => instance.get('/BillBulk/Basic', config), // 取得期別列表簡單資料
    PostBillBulk: (requestData, config) => instance.post('/BillBulk', requestData, config), // 新增期別
    GetBillBulk: (queryPath, config) => instance.get(`/BillBulk/${queryPath.billBulkId}`, config), // 取得期別
    DeleteBillBulk: (queryPath, config) => instance.delete(`/BillBulk/${queryPath.billBulkId}`, config), // 刪除期別
    PutBillBulk: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}`, requestData, config), // 更新期別
    GetBill: (queryPath, config) => instance.get(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}`, config), // 取得繳費單
    DeleteBill: (queryPath, config) => instance.delete(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}`, config), // 刪除繳費單
    PutBill: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}`, requestData, config), // 更新繳費單
    PostBillPrint: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bill/Print`, requestData, config), // 列印繳費單
    GetBillList: (queryPath, requestData, config) => instance.get(`/BillBulk/${queryPath.billBulkId}/Bill`, Object.assign({}, { params: requestData }, config)), // 取得繳費單列表
    PostBill: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bill`, requestData, config), // 新增繳費單
    GetBillTerm: (queryPath, config) => instance.get(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Term`, config), // 取得繳費項目
    PutBillTerm: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Term`, requestData, config), // 更新繳費項目
    GetBillReceipt: (queryPath, config) => instance.get(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Writeoff/Receipt`, config), // 取得繳費單收據
    GetBillReceiptPrint: (queryPath, requestData, config) => instance.get(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Writeoff/Receipt/Print`, Object.assign({}, { params: requestData }, config)), // 列印繳費單收據
    GetImportExcelTemplate: (config) => instance.get('/BillBulk/Bill/ImportExcelTemplate', config), // 匯出空白範本
    PostImportExcelTemplate: (requestData, config) => instance.post('/BillBulk/Bill/ImportExcelTemplate', requestData, config), // 匯入繳費單
    PostBillExport: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bill/Export`, requestData, config), // 匯出篩選繳費單
    PutBillBulkStatus: (queryPath, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Status/${queryPath.billStatusEnum}`, config), // 更新期別狀態 Open/Closed
    // 單個的目前沒在用 PutBillStatus: (queryPath,config) => instance.put( `/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Status/${queryPath.billStatusEnum}`, config ), //更新繳費單狀態
    PutMultiBillStatus: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Bill/Status/${queryPath.billStatusEnum}`, requestData, config), // 更新複數繳費單狀態 Open/Closed
    PutBillBulkId: (queryPath, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/BillBulk/${queryPath.anotherBillBulkId}`, config), // 更換繳費單歸屬期別
    PostWriteoffManual: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Writeoff/Receipt/Manaual`, requestData, config), // 手動收帳
    DeleteWriteoffManual: (queryPath, config) => instance.delete(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Writeoff/Receipt/Manaual/${queryPath.receiptId}`, config), // 刪除手動收帳
    PostNotificationAgain: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bill/Notification/Again`, requestData, config), // 繳費單再通知
    GetTabletBillList: (queryPath, config) => instance.get(`/BillBulk/Tablet/${queryPath.tabletId}/Bill`, config), // 取得戶別繳費單
    PutBillDate: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Bill/ModifyDate`, requestData, config) // 繳費單延期
  },
  Bill: {
    GetBillList: (requestData, config) => instance.get('/Bill', Object.assign({}, { params: requestData }, config)), // 取得繳費單列表
    PutMultiBillStatus: (queryPath, requestData, config) => instance.put(`/Bill/${queryPath.billStatusEnum}`, requestData, config), // 更新複數繳費單狀態 Enable/Close
    PutBillDate: (requestData, config) => instance.put('/Bill/ModifyDate', requestData, config), // 繳費單延期
    PutNotificationAgain: (requestData, config) => instance.put('/Bill/Notification/Again', requestData, config), // 繳費單再通知
    GetBillExport: (requestData, config) => instance.post('/Bill/Export', requestData, config), // 匯出篩選繳費單
    PutBillPrint: (requestData, config) => instance.put('/Bill/Print', requestData, config), // 列印繳費單
    PutBillReceiptPrint: (requestData, config) => instance.put('/Bill/Receipt/Print', requestData, config) // 列印複選收據
  },
  Receipt: {
    GetReiptWay: (config) => instance.get('/Receipt/Way', config), // 取得付款方式列表
    GetEntryReport: (requestData, config) => instance.get('/Receipt/EntryReport', Object.assign({}, { params: requestData }, config)), // 取得入帳報表
    GetEntryReportExport: (requestData, config) => instance.get('/Receipt/EntryReport/Export', Object.assign({}, { params: requestData }, config)) // 匯出入帳報表
  },
  Config: {
    GetCommunitySettingForm: (config) => instance.get('/Config/CommunitySettingForm', config), // 取得社區的繳費服務配置表單
    PutCommunitySettingForm: (requestData, config) => instance.put('/Config/CommunitySettingForm', requestData, config), // 新增社區的繳費服務配置表單
    PutSnapshotCommunityPayWays3_0To3_1: (config) => instance.put('/Config/SnapshotCommunityPayWays/3_0To3_1', config), // 設定社區繳費方式配置 3.0 to 3.1，僅調整沒有 SnapshotCommunityPayWay 的期別
    PutSnapshotCommunityCodeRule3_0To3_1: (config) => instance.put('/Config/SnapshotCommunityCodeRule/3_0To3_1', config) // 設定社區碼規則配置 3.0 to 3.1，僅調整沒有 SnapshotCommunityCodeRule 的期別
  },
  Writeoff: {
    GetWriteoffErrList: (config) => instance.get('/Writeoff/Err', config), // 取得異常入帳款項
    PostWriteoff: (requestData, config) => instance.post('/Writeoff', requestData, config), // 建立銷帳資料
    PutWriteoff: (requestData, config) => instance.put('/Writeoff/ChangeMultipleReceiptToSpecifyBill', requestData, config) // 重新對應銷帳資料
  }
}
